import { EnvironmentProviders, makeEnvironmentProviders, provideAppInitializer, inject } from '@angular/core';
import { AuthFacade } from './auth.facade';

/**
 * Restores any persisted auth session before the app finishes bootstrapping.
 * Add to `app.config.ts` providers.
 */
export function provideAuthBootstrap(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(AuthFacade).bootstrap();
    }),
  ]);
}
